"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePermissionLevelDisplayNames = void 0;
var react_1 = require("react");
var usePermissionsModalContext_1 = require("./usePermissionsModalContext");
function usePermissionLevelDisplayNames() {
    var _js = (0, usePermissionsModalContext_1.usePermissionsModalContext)()._js;
    var permissionLevelToDisplayName = (0, react_1.useMemo)(function () {
        return {
            view: _js('Can View'),
            edit: _js('Can Edit'),
            comment: _js('Can Comment'),
            assign: _js('Can Assign'),
            manage: _js('Can Manage'),
            none: _js('Remove Permissions'),
        };
    }, [_js]);
    return permissionLevelToDisplayName;
}
exports.usePermissionLevelDisplayNames = usePermissionLevelDisplayNames;
